<script>
import { mapState, mapActions } from "vuex";

import LastGaleria from "@/components/intranet/home/LastGaleria.vue";
import LastReconocimiento from "@/components/intranet/home/LastReconocimiento.vue";
import LastNewMovimientos from "@/components/intranet/home/LastNewMovimientos.vue";
import VideoUltimo from "@/components/intranet/home/VideoUltimo.vue";
import PublicarMuro from "@/components/intranet/home/PublicarMuro.vue";
import Muros from "@/components/intranet/home/Muros.vue";
import Footer from "@/components/intranet/footer/Footer.vue";

//FF
import Carrusel from "@/components/Carrusel.vue";
import Loading from "@/components/layout/Loading.vue";
import UsuarioWidget from "@/components/intranet/home/UsuarioWidget.vue";

export default {
  components: {
    LastGaleria,
    LastReconocimiento,
    LastNewMovimientos,
    VideoUltimo,
    PublicarMuro,
    Muros,
    Footer,

    //FF
    Loading,
    Carrusel,
    UsuarioWidget,
  },
  props: {
    userData: {
      type: Object,
      required: false,
    },
    toggleSidebar: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      loadingGaleria: true,
      loadingCumpleanos: true,
      loadingVideo: true,
      loadingIngresos: true,
      loadingMovimientos: true,
      loadingMuro: true,
      loadingReconoce: true,
      butonActive: true,

      idEmpresa: this.$ls.get("user").id_empresa_fk,
      idUsuario: this.$ls.get("user").id_usuario,
      flickityOptions: {
        initialIndex: 3,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        freeScroll: false,
        fade: true,
        selectedAttraction: 0.008,
        friction: 0.3,
      },
      isLoadingMore: false,

      //FF
      loadingCarrusel: true,
      menuHome: [
        {
          id: 1,
          titulo: "Cultura",
          url: "/cultura",
          notificationCount: 0,
          icono: `${this.$basePath}/img/home/link-home-cultura@2x.png`,
        },
        {
          id: 2,
          titulo: "Organigrama",
          url: "/organigrama",
          notificationCount: 0,
          icono: `${this.$basePath}/img/home/link-home-organigrama@2x.png`,
        },
        {
          id: 3,
          titulo: "Reconoce",
          url: "/reconoce",
          notificationCount: 0,
          icono: `${this.$basePath}/img/home/link-home-reconoce@2x.png`,
        },
        {
          id: 4,
          titulo: "Beneficios",
          url: "/beneficios",
          notificationCount: 0,
          icono: `${this.$basePath}/img/home/link-home-beneficios@2x.png`,
        },
        {
          id: 5,
          titulo: "Seguridad",
          url: "/seguridad",
          notificationCount: 0,
          icono: `${this.$basePath}/img/home/link-home-seguridad@2x.png`,
        },
      ],
      menuHomeMovil: "muro",
    };
  },
  computed: {
    ...mapState("home", [
      "listNoticias",
      "listCumpleDay",
      "lastGaleria",
      "lastVideo",
      "listaLastNewIngresos",
      "listLastNewMovimientos",
      "listLastReconociminetos",
      "lastPostsMuro",
    ]),
    ...mapState("NotificacionModule", ["notificaciones"]),
    ...mapState("MenuModule", ["listMenuDestacado"]),
    ...mapState("VistosModule", ["moduloVisto"]),
  },
  created() {
    Promise.all([
      this.GetNoticias(),
      this.GetBirthdays(),
      this.GetListLastGalerias(),
      this.GetLastVideo(),
      this.GetLastMovinmientos(),
      this.GetLastReconocimientos(),
      this.GetLastPostMuro(),
      this.GetNewIngresos(),
    ]);
    this.notificacionesUpdate();
    this.subscribeToModuloVisto({
      idEmpresa: `${this.idEmpresa}`,
      idUsuario: `${this.idUsuario}`,
    });
  },
  methods: {
    ...mapActions("VistosModule", ["subscribeToModuloVisto"]),
    ...mapActions("home", [
      "getNoticias",
      "getCumpleanosDay",
      "getLastGalerias",
      "getLastVideo",
      "getLastNewIngresos",
      "getLastMovimientos",
      "getLastReconocimiento",
      "getLastPostMuro",
      "nextPageLastPostMuro",
    ]),

    aMuro() {
      this.butonActive = true;
      document
        .querySelector(".home__div-muro-movil")
        .classList.remove("d-none");
      document
        .querySelector(".home__div-novedades-movil")
        .classList.add("d-none");
    },
    aNovedades() {
      this.butonActive = false;
      document.querySelector(".home__div-muro-movil").classList.add("d-none");
      document
        .querySelector(".home__div-novedades-movil")
        .classList.remove("d-none");
    },
    async GetBirthdays() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
      };
      this.loadingCumpleanos = true;
      await this.getCumpleanosDay(data_);
      this.loadingCumpleanos = false;
    },
    async GetListLastGalerias() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
      };
      console.log("data_galer: ", data_);

      this.loadingGaleria = true;
      await this.getLastGalerias(data_);
      this.loadingGaleria = false;
    },
    async GetLastVideo() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
      };
      this.loadingVideo = true;
      await this.getLastVideo(data_);
      this.loadingVideo = false;
    },
    async GetNewIngresos() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        limit: "3",
      };

      this.loadingIngresos = true;
      await this.getLastNewIngresos(data_);
      this.loadingIngresos = false;
    },
    async GetLastMovinmientos() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        limit: "3",
      };

      this.loadingMovimientos = true;
      await this.getLastMovimientos(data_);
      this.loadingMovimientos = false;
    },

    async GetLastReconocimientos() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        plataforma: "1",
        fecha_inicio: "",
        fecha_final: "",
        nombre: "",
        limit: "3",
      };

      this.loadingReconoce = true;
      await this.getLastReconocimiento(data_);
      this.loadingReconoce = false;
    },

    async GetLastPostMuro() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
      };

      this.loadingMuro = true;
      await this.getLastPostMuro(data_);
      this.loadingMuro = false;
    },

    //FF
    async GetNoticias() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        limite: "5",
      };
      await this.getNoticias(data_);
      this.loadingCarrusel = false;
    },
    async onScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      if (
        scrollTop + clientHeight + 600 >= scrollHeight - 10 &&
        !this.isLoadingMore
      ) {
        this.isLoadingMore = true;
        await this.nextPageLastPostMuro();
        this.isLoadingMore = false;
      }
    },
    notificacionesUpdate() {
      const notificacionesHash = {};
      // Contar notificaciones por modulo
      this.notificaciones.forEach(({ nombre_modulo }) => {
        const name = nombre_modulo.toLowerCase();
        if (notificacionesHash[name]) {
          notificacionesHash[name]++;
          return;
        }
        notificacionesHash[name] = 1;
      });

      // Limpiar notificaciones
      const menu = this.menuHome.map((e) => ({ ...e, notificationCount: 0 }));
      // Actualizar notificaciones
      this.menuHome = menu.map((e) => {
        const notificationCount =
          notificacionesHash[e.titulo.toLowerCase()] | 0;
        return { ...e, notificationCount };
      });
    },
  },
  watch: {
    toggleSidebar() {
      this.$refs.carrusel.updateCarousel();
    },
    notificaciones() {
      this.notificacionesUpdate();
    },
  },
};
</script>

<template>
  <div id="home" class="home">
    <Carrusel
      ref="carrusel"
      class="mb-5 pb-5 p-lg-0 m-lg-0"
      :data="listNoticias"
      :loading="loadingCarrusel"
    />
    <section id="menu-home" class="menu-home pt-5 mt-5 mb-4 d-none d-lg-block">
      <div class="d-flex flex-row px-5 mx-5">
        <div
          v-for="item in listMenuDestacado"
          :key="item.id"
          class="d-flex flex-fill justify-content-center"
        >
          <router-link
            :to="item.ruta"
            class="menu-home-link text-decoration-none"
          >
            <img
              :src="item.imagen_url"
              alt="Acceder a Cultura"
              class="menu-home-link-img"
            />
            <h3 class="menu-home-link-title color-main text-center">
              {{ item.nombre_modulo }}
            </h3>
            <template v-if="moduloVisto[item.moduloGeneral.id_modulo]">
              <div
                class="menu-home-link-circle"
                v-if="moduloVisto[item.moduloGeneral.id_modulo].no_vistos > 0"
              >
              {{
                moduloVisto[item.moduloGeneral.id_modulo].no_vistos
                }}
              </div>
            </template>
          </router-link>
        </div>
      </div>
    </section>
    <section
      id="menu-home-movil"
      class="d-flex justify-content-center d-xxl-none mb-3"
    >
      <div class="btn-group btn-group-custom">
        <input
          type="radio"
          class="btn-check btn-group-custom-check"
          name="menu-movil"
          id="btn-muro"
          autocomplete="off"
          checked
          value="muro"
          v-model="menuHomeMovil"
        />
        <label class="btn btn-group-custom-label" for="btn-muro"> Muro </label>
        <input
          type="radio"
          class="btn-check btn-group-custom-check"
          name="menu-movil"
          id="btn-novedades"
          autocomplete="off"
          value="novedades"
          v-model="menuHomeMovil"
        />
        <label class="btn btn-group-custom-label" for="btn-novedades">
          Novedades
        </label>
      </div>
    </section>

    <div class="row">
      <div
        id="home-left"
        class="col-12 col-xxl-3"
        :class="
          menuHomeMovil === 'novedades' ? 'd-block' : 'd-none d-xxl-block'
        "
      >
        <LastGaleria :data="lastGaleria" :loading="loadingGaleria" />
        <UsuarioWidget
          :data="listCumpleDay"
          title="Cumpleaños"
          icon="fa-solid fa-cake-candles"
          icon_url="/img/home/img-card-cumpleanios.png"
          :comment="true"
          link="/birthday"
          :loading="loadingCumpleanos"
        />
        <LastReconocimiento
          :data="listLastReconociminetos"
          :loading="loadingReconoce"
        />
      </div>
      <div
        id="home-center"
        class="col-12 col-xxl-6 content-height scroll"
        :class="menuHomeMovil === 'muro' ? 'd-block' : 'd-none d-xxl-block'"
        @scroll="onScroll"
      >
        <PublicarMuro class="mb-3" :userData="userData" />
        <Loading v-if="loadingMuro" pixeles="200px" />
        <Muros v-if="!loadingMuro" :muros="lastPostsMuro" />
      </div>
      <div
        id="home-right"
        class="col-12 col-xxl-3"
        :class="
          menuHomeMovil === 'novedades' ? 'd-block' : 'd-none d-xxl-block'
        "
      >
        <VideoUltimo class="mb-3" :data="lastVideo" :loading="loadingVideo" />
        <UsuarioWidget
          :data="listaLastNewIngresos"
          title="Nuevos ingresos"
          icon="fa-solid fa-user-plus"
          icon_url="/img/home/icono-nuevo-ingreso.svg"
          :comment="false"
          :loading="loadingIngresos"
        />
        <Loading v-if="loadingMovimientos" pixeles="100px" />
        <LastNewMovimientos
          v-if="!loadingMovimientos"
          :LastNewMovimientos="listLastNewMovimientos"
        />
      </div>
    </div>

    <Footer :userData="userData" />
  </div>
</template>
